import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Flex,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { TbDots } from 'react-icons/tb';
import { MdArchive, MdPublish } from 'react-icons/md';

import theme from 'ui/theme/theme';
import Text from 'ui/Text';

function BlogActionMenu({ item, updateStatus }) {
  const navigate = useNavigate();
  // console.log('publish ?: ', item?.status);
  return (
    <Menu placement="bottom-end">
      <MenuButton as={Button} bg="unset">
        <Flex justifyContent="center">
          <TbDots color={theme.colors.semantics.link} />
        </Flex>
      </MenuButton>
      <MenuList
        padding="8px"
        w="150px"
        borderWidth="0px"
        boxShadow="0px 4px 30px 0px rgba(0, 0, 0, 0.15)"
      >
        <MenuItem
          p="8px"
          as="button"
          onClick={() => navigate(`/edit-blog/${item?.blogId}`)}
        >
          <Flex alignItems="center" color="semantics.link">
            <FaEdit />
            <Text size="medium" ml="8px" fontWeight="bold">
              Edit
            </Text>
          </Flex>
        </MenuItem>

        {item?.status == 'Published' && (
          <MenuItem
            p="8px"
            as="button"
            onClick={() => updateStatus(item?.blogId, 3)}
          >
            <Flex alignItems="center" color="semantics.link">
              <MdArchive />
              <Text size="medium" ml="8px" fontWeight="bold">
                Archive
              </Text>
            </Flex>
          </MenuItem>
        )}
        {!(item?.status == 'Published') && (
          <MenuItem
            p="8px"
            as="button"
            onClick={() => updateStatus(item?.blogId, 2)}
          >
            <Flex alignItems="center" color="semantics.link">
              <MdPublish />
              <Text size="medium" ml="8px" fontWeight="bold">
                Publish
              </Text>
            </Flex>
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  );
}

BlogActionMenu.propTypes = {
  item: PropTypes.object,
  updateStatus: PropTypes.func,
};

export default BlogActionMenu;
